<template>
  <div>
    <v-card flat class="mx-auto my-6" min-height="600" max-width="1000" id="element-to-print">
      <v-card-title class="my-0">
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="12">
            <p class="text-h6 text-center">KUWAIT <br> LEASE COTRACT</p>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="12"></v-col>
        </v-row>
      </v-card-title>
      <v-row class="ma-0 mx-12 mt-n3">
        <v-col cols="12" lg="6" md="6" sm="12" class="my-0 mt-n7">
          <label>LANDLORD:{{ bookingDetails[0].customer.firstName || '' + 
            bookingDetails[0].customer.lastName || ''}}</label>
            <hr>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12"></v-col>
        <v-col cols="12" lg="6" md="6" sm="12" class="my-0 mt-n7">
          <label>ADDRESS: <u class="mx-2">
            {{
              bookingDetails[0].property.address.area.nameEn || '-'
            }}
            </u></label>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12"></v-col>
        <v-col cols="12" lg="6" md="6" sm="12" class="my-0 mt-n7">
          <label>Civil Id Number: <u class="mx-2">
            {{
              bookingDetails[0].customer.civilIdNumber || '-'
            }}</u></label>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12"></v-col>
        <v-col cols="12" lg="6" md="6" sm="12" class="my-0 mt-n7">
          <label>TELL NR: <u class="mx-2">
            {{
              bookingDetails[0].customer.phone || '-'
            }}</u></label>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12"></v-col>
      </v-row>
        <!-- <label for="">
          <b>Customer Name: </b>{{ bookingDetails[0].customer.firstName }}
        </label>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <label class="subtitle-1">
          {{ bookingDetails[0].property.nameEn }}
        </label>
        <v-row>
          <v-col>
            {{ bookingDetails[0].property.address.area.nameEn }},
            {{ bookingDetails[0].property.address.addressLine1 }}
          </v-col>
          <v-col>
            <label class="subtitle-1">
              {{ 'Check In' }}
            </label>
            {{ bookingDetails[0].checkInDate }}
          </v-col>
          <v-col>
            <label class="subtitle-1">
              {{ 'Check out' }}
            </label>
            {{ bookingDetails[0].checkOutDate }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            Booking Id:
          </v-col>
          <v-col cols="3">
            {{ bookingDetails[0].bookingId }}
          </v-col>
          <v-col cols="3">
            Booking Date
          </v-col>
          <v-col cols="3">
            {{ bookingDetails[0].bookingDate }}
          </v-col>
          <v-col cols="3">
            Adult
          </v-col>
          <v-col cols="3">
            {{ bookingDetails[0].adult }}
          </v-col>
          <v-col cols="3">
            Child
          </v-col>
          <v-col cols="3">
            {{ bookingDetails[0].child }}
          </v-col>
          <v-col cols="3">
            Infant
          </v-col>
          <v-col cols="3">
            {{ bookingDetails[0].infant }}
          </v-col>
          <v-col cols="3">
            Price
          </v-col>
          <v-col cols="3">
            {{ bookingDetails[0].price }}
          </v-col>
        </v-row> -->
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import jsPDF from 'jspdf'
// import html2pdf from "html2pdf.js";
import 'jspdf-autotable'
export default {
  data () {
    return {
      bookingId: this.$route.params.id,
      bookingDetails: {},
      totalBooking: 0
    }
  },
  components: {
    // "footer-bar": () => import("@/core/components/Footer")
  },
  apollo: {
    getAllBookings() {
      return {
        query: require("@/bookings/api/queries/booking_by_id_query.graphql"),
        variables: {
          bookingId: this.bookingId
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          // this.generatePdf()
          this.bookingDetails = this.$format.cloneVariable(
            data.getBookingById.bookings
          );
          this.loading = loading;
          this.totalBooking = data.getBookingById.totalCount;
          this.generatePDF()
        }
      };
    }
  },
  methods: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    generatePDF() {
      const details = this.bookingDetails[0]
      // const address = details.property.address.addressLine1.match(/.{1,25}/g);
      const doc = new jsPDF("p", "pt");
      doc
        .setFont("times")
        .setFontSize(16)
        .text(140, 30, "KUWAIT");
      doc
        .setFont("times")
        .setFontSize(13)
        .text(120, 45, "LEASE COTRACT");
        // For landlord
      doc
        .setFont("times")
        .setFontSize(11)
        .setTextColor(0, 0, 0)
        .text(25, 70, "LANDLORD:");
      doc
        .setFont("times")
        .setFontSize(12)
        .text(93, 70, details.customer.firstName || '' + 
              details.customer.lastName || '');
      doc.line(93, 73, 280, 73); //name underline for english
      doc.line(500, 73, 300, 73); //name underline for arabic
      // Address
      doc
        .setFont("times")
        .setFontSize(11)
        .setTextColor(0, 0, 0)
        .text(25, 88, "ADDRESS:");
      doc
        .setFont("times")
        .setFontSize(11)
        .text(93, 88, details.property.address.area.nameEn || '-');
      doc.line(93, 88 + 4, 280, 88 + 4);
      // Civil Id number
      doc
        .setFont("times")
        .setFontSize(11)
        .setTextColor(0, 0, 0)
        .text(25, 104, "Civil Id Number:");
      doc
        .setFont("times")
        .setFontSize(11)
        .text(103, 104, details.customer.civilIdNumber || '-');
      doc.line(103, 108, 280, 108);
      // Tell Number
       doc
        .setFont("times")
        .setFontSize(11)
        .setTextColor(0, 0, 0)
        .text(25, 125, "TELL NR:");
      doc
        .setFont("times")
        .setFontSize(11)
        .text(93, 125, details.customer.phone || '-');
      doc.line(93, 128, 280, 128);
      // doc.setLineWidth(2)
      // doc.line(560, 725, 40, 725)
      doc.addPage()
      doc.addPage()
      doc.save(`customerContract.pdf`);
    }
  }
}
</script>

<style>

</style>